import styled from "styled-components";

export const StyledImageAttachment = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    max-width: min(30rem, 80vw);

    > .image-preview {
        background: transparent;
        border: 0;
        border-radius: 0.25rem;
        cursor: zoom-in;
        display: block;
        max-width: 100%;
        overflow: hidden;
        padding: 0;
        position: relative;

        > img {
            display: block;
            max-height: 12rem;
            max-width: 100%;
            object-fit: contain;
        }

        > span {
            align-items: center;
            background-color: rgba(0, 0, 0, 0.68);
            bottom: 0.5rem;
            color: white;
            display: flex;
            font-size: 0.75rem;
            gap: 0.35rem;
            opacity: 0;
            padding: 0.4rem 0.55rem;
            pointer-events: none;
            position: absolute;
            right: 0.5rem;
            transition: opacity 0.15s ease-in-out;
        }

        &:hover > span,
        &:focus-visible > span {
            opacity: 1;
        }

        &:focus-visible {
            outline: 2px solid var(--color-primary);
            outline-offset: 2px;
        }
    }
`;

export const StyledImageActions = styled.div`
    display: flex;
    gap: 0.35rem;
    justify-content: flex-end;

    > button {
        align-items: center;
        background-color: var(--color-grey-7);
        border-radius: 0.25rem;
        color: var(--color-grey-2);
        cursor: pointer;
        display: flex;
        font-size: 0.75rem;
        gap: 0.3rem;
        padding: 0.35rem 0.5rem;

        &:hover:not(:disabled),
        &:focus-visible {
            background-color: var(--color-primary-o);
            color: white;
        }

        &:disabled {
            cursor: wait;
            opacity: 0.65;
        }
    }
`;

export const StyledImageViewer = styled.aside`
    background-color: rgba(0, 0, 0, 0.9);
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100vh;
    inset: 0;
    position: fixed;
    width: 100vw;
    z-index: 1000;

    > header {
        align-items: center;
        background-color: rgba(20, 20, 20, 0.96);
        color: white;
        display: flex;
        gap: 1rem;
        justify-content: space-between;
        min-height: 3.25rem;
        padding: 0.5rem 1rem;

        > p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        > div {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            gap: 0.4rem;

            > button {
                align-items: center;
                background-color: rgba(255, 255, 255, 0.12);
                border-radius: 0.25rem;
                color: white;
                cursor: pointer;
                display: flex;
                gap: 0.35rem;
                justify-content: center;
                min-height: 2.25rem;
                min-width: 2.25rem;
                padding: 0.45rem 0.6rem;

                &:hover:not(:disabled),
                &:focus-visible {
                    background-color: var(--color-primary);
                }

                &:disabled {
                    cursor: not-allowed;
                    opacity: 0.45;
                }
            }
        }
    }

    > .image-area {
        align-items: center;
        display: flex;
        justify-content: center;
        overflow: auto;
        padding: 1.5rem;

        > img {
            max-height: calc(100vh - 6.25rem);
            max-width: calc(100vw - 3rem);
            object-fit: contain;
            transform-origin: center;
            transition: transform 0.15s ease-in-out;
        }
    }

    @media (max-width: 40rem) {
        > header {
            > p {
                display: none;
            }

            > div {
                justify-content: space-between;
                width: 100%;

                > button span {
                    display: none;
                }
            }
        }
    }
`;
